<footer class="main-footer">
    © 2023 PTC All Rights Reserved.
    <div class="float-right d-none d-sm-inline-block">
      Version <b>1.4.5</b>
    </div>
  </footer>
    
